(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const init = () => {
    if (!reduce && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => es.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('sm-in'); io.unobserve(e.target); }
      }), { rootMargin: '0px 0px -8% 0px' });
      // Skip the first section so the hero shows instantly.
      document.querySelectorAll('main .shopify-section').forEach((s, i) => {
        if (i === 0 || s.getBoundingClientRect().top < innerHeight) return;
        s.classList.add('sm-reveal'); io.observe(s);
      });
      document.querySelectorAll('main img').forEach((img) => {
        if (img.complete) return;
        img.classList.add('sm-img');
        const done = () => img.classList.add('sm-loaded');
        img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true });
      });
    }
    // Waitlist: submit in place; fall back to a normal post if Shopify asks for a challenge.
    const f = document.getElementById('ComingSoonNotify-ProductForm');
    if (f && window.fetch) f.addEventListener('submit', async (ev) => {
      ev.preventDefault();
      const btn = f.querySelector('button[type=submit]'); btn.disabled = true;
      try {
        const r = await fetch(f.action, { method: 'POST', body: new FormData(f), credentials: 'same-origin' });
        if (!r.ok || /challenge/.test(r.url)) throw 0;
        if (/customer_posted=true/.test(r.url)) {
          f.querySelector('.sm-msg')?.remove();
          const m = document.createElement('p'); m.className = 'sm-msg'; m.setAttribute('role', 'status');
          m.textContent = "You're on the list. We'll email you when it launches.";
          f.append(m); f.querySelector('input[type=email]').value = ''; btn.disabled = false; return;
        }
        // Trust only the server-rendered result for this form.
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        const res = doc.querySelector('#ComingSoonNotify-ProductForm .sm-msg');
        if (!res) throw 0;
        f.querySelector('.sm-msg')?.remove();
        f.append(document.importNode(res, true));
        if (res.getAttribute('role') === 'status') f.querySelector('input[type=email]').value = '';
      } catch { f.submit(); }
      btn.disabled = false;
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
